import CASL from '@/utils/constants/casl'

export default [
  {
    path: 'contact',
    name: 'app-content.contact',
    meta: {
      title: 'Contact Information',
      action: 'read',
      subject: CASL.ACCESS.CONTACT_INFORMATION
    },
    component: () => import('./ContactPage.vue')
  }
]
